import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherLabels } from '#pplx/frontend/aether/internal/labels/useAetherLabels.js';
import React from 'react';
export const ComputerMark = React.memo(function ComputerMark(divProps) {
    const labels = useAetherLabels();
    return (_jsx("div", { ...divProps, children: _jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "h-auto w-full", role: "img", "aria-label": labels.logoComputer, children: _jsx("use", { href: "#pplx-logo-computer-mark" }) }) }));
});
//# sourceMappingURL=ComputerMark.js.map